import { defineComponent as v, ref as w, onMounted as g, onBeforeUnmount as T, openBlock as n, createElementBlock as l, normalizeClass as d, normalizeStyle as E, createElementVNode as a, renderSlot as r, createTextVNode as m, toDisplayString as i, createVNode as S, unref as I, createCommentVNode as u, withDirectives as b, vShow as p } from "vue";
import { useZIndex as L } from "element-plus";
import M from "@patsnap-biz/icon";
import "@patsnap-ui/icon/assets/solid/CloseBig.svg";
const z = {
  key: 0,
  class: "th-modal-box"
}, D = { class: "th-modal-title" }, H = ["innerHTML"], N = {
  key: 1,
  class: "th-modal-content"
}, P = { class: "th-modal-action" }, V = ["disabled"], U = ["disabled"], Z = /* @__PURE__ */ v({
  __name: "Dialog",
  props: {
    title: {},
    visible: { type: Boolean, default: !1 },
    message: {},
    dangerouslyUseHTMLString: { type: Boolean, default: !1 },
    zIndex: {},
    customClass: {},
    callback: {},
    showClose: { type: Boolean, default: !0 },
    beforeClose: {},
    showCancelButton: { type: Boolean, default: !1 },
    showConfirmButton: { type: Boolean, default: !0 },
    cancelButtonText: { default: "Cancel" },
    confirmButtonText: { default: "Confirm" },
    cancelButtonClass: {},
    confirmButtonClass: {},
    disableConfirmButton: { type: Boolean, default: !1 },
    disableCancelButton: { type: Boolean, default: !1 },
    closeOnPressEscape: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:visible"],
  setup(h, { emit: s }) {
    const o = h, { nextZIndex: y } = L(), f = w(2e3);
    function t(e) {
      if (typeof o.beforeClose == "function") {
        o.beforeClose(e, () => {
          o.callback && o.callback(e), s("close", e), s("update:visible", !1);
        });
        return;
      }
      o.callback && o.callback(e), s("close", e), s("update:visible", !1);
    }
    function c(e) {
      e.code === "Escape" && o.closeOnPressEscape && t("esc");
    }
    function C() {
      t("cancel");
    }
    function B() {
      t("close");
    }
    function k() {
      t("confirm");
    }
    return g(() => {
      f.value = y(), window.addEventListener("keydown", c);
    }), T(() => {
      window.removeEventListener("keydown", c);
    }), (e, $) => e.visible ? (n(), l("div", {
      key: 0,
      class: d(["th-modal", e.customClass]),
      style: E({ zIndex: f.value }),
      open: "",
      onKeydown: c
    }, [
      e.visible ? (n(), l("div", z, [
        a("div", D, [
          r(e.$slots, "title", {
            data: { close: t }
          }, () => [
            m(i(e.title), 1)
          ]),
          e.showClose ? (n(), l("button", {
            key: 0,
            class: "th-btn th-btn-plain th-btn-sm th-btn-only-icon",
            onClick: B
          }, [
            S(I(M), {
              icon: "SolidCloseBig",
              class: "text-2xl leading-6 text-gray-500 fill-gray-500"
            })
          ])) : u("", !0)
        ]),
        e.dangerouslyUseHTMLString ? (n(), l("p", {
          key: 0,
          class: "th-modal-content",
          innerHTML: e.message
        }, null, 8, H)) : (n(), l("p", N, [
          r(e.$slots, "default", {
            data: { close: t }
          }, () => [
            m(i(e.message), 1)
          ])
        ])),
        a("div", P, [
          r(e.$slots, "footer", {
            data: { close: t }
          }, () => [
            b(a("button", {
              type: "button",
              class: d(["th-btn", e.cancelButtonClass || "th-btn-secondary"]),
              disabled: e.disableCancelButton,
              onClick: C
            }, i(e.cancelButtonText), 11, V), [
              [p, e.showCancelButton]
            ]),
            b(a("button", {
              type: "button",
              class: d(["th-btn", e.confirmButtonClass]),
              disabled: e.disableConfirmButton,
              onClick: k
            }, i(e.confirmButtonText), 11, U), [
              [p, e.showConfirmButton]
            ])
          ])
        ])
      ])) : u("", !0)
    ], 38)) : u("", !0);
  }
}), q = Z;
export {
  q as PtDialog,
  q as default
};
